import {h, Fragment} from "preact"
import { useProductBadges } from "../../../hooks/useProductBadges"

export default function Badges ({ product }) {
    
    const { badges } = useProductBadges({ product }) 

    return (
        <div className="product-badges">
            {badges.map(badge => (
                <div className={`badge ${badge.className}`}>{badge.label}</div>
            ))}
        </div> 
    )
} 